import { Card, CardContent, CardHeader, Divider, Grid, Typography } from "@mui/material";
import { SkeletonIndicator } from "../../../../components/skeleton-indicator.component";
import dayjs from "dayjs";

interface MunicipalityInfoProps {
    municipality?: any;
    isLoading?: boolean;
}

interface ComponentCell {
    isLoading: any;
    heading: string;
    value: any;
}

const styling = {
    root: { borderRadius: '10px' },
    textColor: { color: '$primary-color' },
    headingStyle: { color: '#0000b5', paddingBottom: '10px' },
    labelStyle: { color: '#0000b5', fontSize: '14px' },
    valueStyle: { color: '#000', fontWeight: '500', fontSize: '13px' },
};

const ComponentCell = ({ isLoading, heading, value }: ComponentCell) => {
    return (
        <Grid container spacing={0.5}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <Typography variant="body1" color="textPrimary" style={styling.labelStyle}>
                    {heading}
                </Typography>
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                {!isLoading ? (
                    <Typography variant="body1" color="text.secondary" style={styling.valueStyle}>
                        {value ? value : 'N/A'}
                    </Typography>
                ) : (
                    <SkeletonIndicator isLoading={isLoading} count={1} variant="h6" />
                )}
            </Grid>
        </Grid>
    );
};

export const setValue = (value: string) => {
    const parsed = dayjs(value, 'HH:mm:ss.SSSSSSS'); // this matches "17:00:00.0000000"
    return dayjs().set('hour', parsed.hour()).set('minute', parsed.minute());
};

export const MunicipalityInfo = ({ municipality, isLoading }: MunicipalityInfoProps) => {
    
    return (
        <Card elevation={0}>
            <CardHeader
                className="subHead"
                title={
                    <Typography variant="h3" color="textPrimary" style={styling.headingStyle}>
                        MUNICIPALITY INFO
                    </Typography>
                }
            />
            <Divider sx={{ borderBottomWidth: '2px' }} />
            <CardContent>
                <Grid container spacing={2} className="custBoxValues">
                     <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <ComponentCell isLoading={isLoading} heading="Municipality Name" value={municipality?.muncipalityName} />
                    </Grid>
                    <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <ComponentCell isLoading={isLoading} heading="Municipality Code" value={municipality?.municipalityCode} />
                    </Grid>
                   
                  
                    <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <ComponentCell isLoading={isLoading} heading="State" value={municipality?.state} />
                    </Grid>
                    <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <ComponentCell isLoading={isLoading} heading="Contact Email" value={municipality?.contactEmail} />
                    </Grid>
                      <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <ComponentCell isLoading={isLoading} heading="Cut-off Time" value={municipality?.cutOffTime && setValue(municipality?.cutOffTime).format('hh:mm A')} />
                    </Grid>
                     <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <ComponentCell isLoading={isLoading} heading="Status" value={municipality?.status} />
                    </Grid>
                    <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <ComponentCell isLoading={isLoading} heading="Inspection Report Required"
                            value={municipality?.sendInsReport ? 'Yes' : 'No'} />
                    </Grid>   
                               
                    <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <ComponentCell isLoading={isLoading} heading="CoC Required" value={municipality?.coCRequired ? 'Yes' : 'No'} />
                    </Grid>
                      
                    <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <ComponentCell isLoading={isLoading} heading="Inspection Report Required For CoC"
                            value={municipality?.inspectionReportRequiredForCoC ? 'Yes' : 'No'} />
                    </Grid>
                    
                </Grid>
            </CardContent>
        </Card>
    );
}